import type { ElementDescription, ElementDescriptionDimension, ElementDescriptionMetric } from '../internalTypes'
import { TableColumnValuesChoice } from '../constants'
import { assertNever } from './generics'

export const elementDescriptionIsDimension = (
  elementDescription?: ElementDescription
): elementDescription is ElementDescriptionDimension => {
  if (elementDescription == null) {
    return false
  }
  const { type } = elementDescription
  switch (type) {
    case 'number':
    case 'currency':
    case 'percentage':
      return false
    case 'date':
    case 'string':
    case 'variant':
      return true
    case 'dimension':
    case 'value':
    case 'valueOf':
    case 'values':
    case 'valuesOf':
    case 'variantValue':
    case 'variantValues':
    case TableColumnValuesChoice:
      return false
    case 'metric':
    case 'metrics':
    case 'metricVariants':
    case 'metricTransposed':
      return false
    default:
      assertNever(type)
      return false
  }
}

export const elementDescriptionIsMetric = (
  elementDescription?: ElementDescription
): elementDescription is ElementDescriptionMetric => {
  if (elementDescription == null) {
    return false
  }
  const { type } = elementDescription
  switch (type) {
    case 'number':
    case 'currency':
    case 'percentage':
      return true
    case 'date':
    case 'string':
    case 'variant':
      return false
    case 'dimension':
    case 'value':
    case 'valueOf':
    case 'values':
    case 'valuesOf':
    case 'variantValue':
    case 'variantValues':
    case TableColumnValuesChoice:
      return false
    case 'metric':
    case 'metrics':
    case 'metricVariants':
    case 'metricTransposed':
      return false
    default:
      assertNever(type)
      return false
  }
}
